import globalConfig from '@/core/config/app';

class MercureUtil {
  constructor() {

  }

  static subscribeTopic(topic, handler) {
  }
}

export default MercureUtil;
